import { render, staticRenderFns } from "./MyLikeListForm.vue?vue&type=template&id=53852dfd&"
import script from "./MyLikeListForm.vue?vue&type=script&lang=js&"
export * from "./MyLikeListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports